import React from "react";
import { useHistory } from "react-router";
import StarRatings from "react-star-ratings";

export default function Review(props) {
  const review = props.review;
  const history = useHistory();
  console.log("review: ", review);

  String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  };

  const getFromName = () => {
    if (review.Social) {
      return "a " + review.Social.platform.capitalize() + " user";
    }
    if (review.Business) {
      return (
        <a onClick={() => history.push(`/business/${review.Business.id}`)}>
          {review.Business.name}
        </a>
      );
    }
  };

  return (
    <div className="mt-3 ml-2">
      <hr></hr>
      <h5>{review.title}</h5>
      <StarRatings
        rating={review.stars}
        starRatedColor="gold"
        starDimension="20px"
        starSpacing="1px"
        starHoverColor="gold"
        numberOfStars={5}
        name="rating"
      />
      <p>
        <i>From: {getFromName()}</i>
      </p>
      <p>{review.body}</p>
    </div>
  );
}
